import type { LoggerClient } from 'clients/logger/interface'
import { SentryLogger } from 'clients/logger/sentry-logger'

export type { LoggerClient, LoggerContext } from 'clients/logger/interface'

export const logger: LoggerClient = new SentryLogger()
